import axios from "axios";

export const state = {
    patient_saving: false,
    patients: [],
    max_registered:"",
    activepatients: [],
    returningpatients: [],
    patient_profile: {},
    villages: [],
    removed_services: [],
    patient_facilities: [],
    triage_patients:[]
};

export const getters = {
    all_patients: state => state.patients.data,
    RemovedServices: state => state.removed_services.data,
    active_patients: state => state.activepatients.data,
    ReturningPatients: state => state.returningpatients.data,
    saving_status: state => state.patient_saving,
    PatientProfileDetails: state => state.patient_profile.data,
    TriagePatients: state => state.triage_patients,
    max_registered: state => state.max_registered,
    Villages: state => state.villages.filter((element) => {
        return element.name != ""
    }),
    Facilities: state => state.patient_facilities.data,
};
export const mutations = {
    SET_SAVE_STATUS: (state, newValue) => state.patient_saving = newValue,
    SET_PATIENTS: (state, newValue) => state.patients = newValue,
    SET_MAX_REGISTERED_PATIENT: (state, newValue) => state.max_registered = newValue,
    SET_REMOVED_SERVICES: (state, newValue) => state.removed_services = newValue,
    SET_ACTIVE_PATIENTS: (state, newValue) => state.activepatients = newValue,
    SET_RETURNING_PATIENTS: (state, newValue) => state.returningpatients = newValue,
    SET_PATIENT_REAL_PROFILE: (state, newValue) => state.patient_profile = newValue,
    SET_PATIENT_PROFILE_TEMPALET: (state) => state.patient_profile = {},
    SET_VILLAGES: (state, newValue) => state.villages = newValue,
    SET_FACILITIES: (state, newValue) => state.patient_facilities = newValue,
    SET_TRIAGE_PATIENTS: (state, newValue) => state.triage_patients = newValue,
};
export const actions = {
    addPatient({ dispatch, commit }, patient) {
        commit('SET_SAVE_STATUS', true)
        setTimeout(() => {
            dispatch('fetchReturningPatients')
        }, 1000);
        axios.post('patient', patient).then((data) => {
            commit('SET_MAX_REGISTERED_PATIENT',data.data)
            dispatch('fetchTriagePatients')
            dispatch('fetchActivePatients')
            dispatch('fetchPatients')
            dispatch('fetchVillages')
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Patient Registed successfully" }
                // DISPACH MESSAGE MODUL
            dispatch('notification/success', message, { root: true })
                // dispack returning
            dispatch('fetchReturningPatients')
                // DISPACH DOCTOR SECTION
            setTimeout(() => {
                dispatch('doctor/fetchConsultationPatients', null, { root: true })
                dispatch('doctor/fetchRadiologyPatients', null, { root: true })
                dispatch('doctor/fetchProcedurePatients', null, { root: true })
                dispatch('doctor/fetchAntenatalPatients', null, { root: true })
                dispatch('doctor/fetchDentalPatients', null, { root: true })
            }, 1000);

        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Registering patient" }
            dispatch('notification/error', message, { root: true })

        })
    },
    fetchPatients({ commit, dispatch }) {
        axios.get('patient').then(pres => {
            commit('SET_PATIENTS', pres.data)
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
        })
    },
    fetchRemovedServices({ commit, dispatch }) {
        axios.get('removed_services').then(pres => {
            commit('SET_REMOVED_SERVICES', pres.data)
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
        })
    },
    fetchVillages({ commit, dispatch }) {
        axios.get('villages').then(pres => {
            commit('SET_VILLAGES', pres.data)
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
        })
    },
    fetchFacilities({ commit, dispatch }) {
        axios.get('facilities').then(pres => {
            commit('SET_FACILITIES', pres.data)
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }

        })
    },
    editPatients({ commit, dispatch }, patient) {
        commit('SET_SAVE_STATUS', true)
        axios.put(`patient/${patient.id}`, patient).then((pres) => {
            commit('SET_PATIENTS', pres.data)
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Patient edited successfully" }
                // DISPACH MESSAGE MODUL
            dispatch('notification/success', message, { root: true })
                // dispack returning
            dispatch('fetchReturningPatients')
                // DISPACH DOCTOR SECTION
            setTimeout(() => {
                dispatch('doctor/fetchConsultationPatients', null, { root: true })
                dispatch('doctor/fetchRadiologyPatients', null, { root: true })
                dispatch('doctor/fetchProcedurePatients', null, { root: true })
                dispatch('doctor/fetchAntenatalPatients', null, { root: true })
                dispatch('doctor/fetchDentalPatients', null, { root: true })
            }, 1000);
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error editing patient" }
            dispatch('notification/error', message, { root: true })


        })
    },


    editVisit({ commit, dispatch }, visit) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`visits/${visit.id}`, visit).then(pres => {
            commit('SET_PATIENTS', pres.data)
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Patient Visit edited successfully" }
                // DISPACH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            dispatch('doctor/fetchDiagnosisDetailsNotes', visit.id , { root: true })
                // dispatch returning
            dispatch('fetchActivePatients')
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error editing patient visit" }
            dispatch('notification/error', message, { root: true })

        })
    },
    removeService({ commit, dispatch }, service) {
        commit('SET_SAVE_STATUS', true)
        axios.post(`removeservice`, service).then(() => {
            dispatch('fetchActivePatients')
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Service removed successfully" }
            dispatch('notification/success', message, { root: true })
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Removing service" }
            dispatch('notification/error', message, { root: true })


        })
    },
    fetchActivePatients({ commit, dispatch }) {
        axios.get('activepatients').then(pres => {
            commit('SET_ACTIVE_PATIENTS', pres.data)
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
        })
    },
    fetchReturningPatients({ commit, dispatch }) {
        axios.get('patients_returning').then(rres => {
            commit('SET_RETURNING_PATIENTS', rres.data)
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
        })
    },

    fetchPatientRealProfile({ commit, dispatch }, patient_id) {
        commit('SET_PATIENT_PROFILE_TEMPALET')
        axios.get(`patient/${patient_id}`).then(ppres => {
            commit('SET_PATIENT_REAL_PROFILE', ppres.data)
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
        })
    },

    fetchTriagePatients({commit, dispatch},){
    axios.get('triage_patients').then(ppres => {
            commit('SET_TRIAGE_PATIENTS', ppres.data)
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
        })
    },

  saveTriage({ dispatch, commit }, patient) {
        commit('SET_SAVE_STATUS', true)
        setTimeout(() => {
            dispatch('fetchTriagePatients')
        }, 1000);
        axios.post('savetriage', patient).then(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Triage records saved successfully" }
                // DISPACH MESSAGE MODUL
            dispatch('notification/success', message, { root: true })
            dispatch('fetchTriagePatients')

        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error saving Triage records" }
            dispatch('notification/error', message, { root: true })

        })
    },


};